import vcSocialBar from './components/vc-social-bar'

export default vcSocialBar



// WEBPACK FOOTER //
// ./src/lib.js